export default __webpack_public_path__ + "static/media/extra-bed-v2.50f7af7c.svg";